import weblog from '@ky/sdk/dist/log/kylogger';
export default weblog;
